import {createContext, type PropsWithChildren, use} from 'react';

import {useStorageState} from './useStorageState';
import {Session} from "@/lib/types";

const AuthContext = createContext<{
    session?: Session | null;
    setSession: (session: Session) => void;
    clearSession: () => void;
    isLoading: boolean;
}>({
    session: null,
    setSession: (_session: Session) => {
    },
    clearSession: () => {
    },
    isLoading: false,
});

// Use this hook to access the user info.
export function useSession() {
    const value = use(AuthContext);
    if (!value) {
        throw new Error('useSession must be wrapped in a <SessionProvider />');
    }

    return value;
}

export function SessionProvider({children}: PropsWithChildren) {
    const [[isLoading, session], setSession] = useStorageState('session');

    function setSessionInner(session: Session) {
        setSession(JSON.stringify(session));
    }

    function clearSession() {
        setSession(null);
    }

    let parsedSession: Session | null = null;
    if (session) {
        try {
            parsedSession = JSON.parse(session)
        } catch (err) {
            console.error("Session contains non-JSON", err)
        }
    }

    return (
        <AuthContext.Provider
            value={{
                session: parsedSession,
                setSession: setSessionInner,
                clearSession,
                isLoading,
            }}>
            {children}
        </AuthContext.Provider>
    );
}